/**
 * Positions carousel arrows vertically centered on the first product image
 * by calculating the offset based on the image height
 */

function positionResourceListCarouselArrows() {
  const carousels = document.querySelectorAll('.resource-list__carousel')

  carousels.forEach((carousel) => {
    const arrows = carousel.querySelector('slideshow-arrows')
    if (!arrows) return

    // Find the first slide
    const firstSlide = carousel.querySelector('.resource-list__slide')
    if (!firstSlide) return

    // Find the first image in the first slide (could be in card-gallery or directly in slide)
    const firstImage = firstSlide.querySelector('.card-gallery__image, img')
    if (!firstImage) return

    // Wait for image to load if it hasn't already
    const updateArrowPosition = () => {
      // Find the card-gallery container (parent of the image)
      const cardGallery = firstImage.closest('.card-gallery')
      if (!cardGallery) return

      const cardGalleryRect = cardGallery.getBoundingClientRect()
      const carouselRect = carousel.getBoundingClientRect()

      if (cardGalleryRect.height > 0 && carouselRect.height > 0) {
        // Calculate the center of the card-gallery relative to the carousel
        const cardGalleryTop = cardGalleryRect.top - carouselRect.top
        const cardGalleryCenter = cardGalleryTop + cardGalleryRect.height / 2

        // Calculate the center of the carousel
        const carouselCenter = carouselRect.height / 2

        // Offset = card-gallery center - carousel center
        const offset = cardGalleryCenter - carouselCenter

        // Apply offset using CSS variable
        arrows.style.setProperty('--arrow-offset', `${offset}px`)
      }
    }

    // If image is already loaded, update immediately
    if (firstImage.complete && firstImage.naturalHeight > 0) {
      updateArrowPosition()
    } else {
      // Wait for image to load
      firstImage.addEventListener('load', updateArrowPosition, { once: true })
    }

    // Also update on resize
    let resizeTimeout
    const handleResize = () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(updateArrowPosition, 100)
    }
    window.addEventListener('resize', handleResize)

    // Clean up resize listener when carousel is removed
    const observer = new MutationObserver(() => {
      if (!document.contains(carousel)) {
        window.removeEventListener('resize', handleResize)
        observer.disconnect()
      }
    })
    observer.observe(document.body, { childList: true, subtree: true })
  })
}

// Run on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', positionResourceListCarouselArrows)
} else {
  positionResourceListCarouselArrows()
}

// Also run when new carousels are added (e.g., via AJAX)
if (typeof MutationObserver !== 'undefined') {
  const carouselObserver = new MutationObserver((mutations) => {
    let shouldUpdate = false
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (
            node.classList?.contains('resource-list__carousel') ||
            node.querySelector?.('.resource-list__carousel')
          ) {
            shouldUpdate = true
          }
        }
      })
    })
    if (shouldUpdate) {
      positionResourceListCarouselArrows()
    }
  })

  carouselObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

export default positionResourceListCarouselArrows
